// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IDUA","comment":"styles_comment__WpqV-"};